module.exports = __webpack_public_path__ + "static/media/way-out-is-through.534f4e86.jpg";